import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { environment } from '../../../../../environments/environment';

export interface MediasList {
    media: string;
    rule: string;
    plays: string;
    impressions: string;
    budget: string;
    cost: string;
}

@Component({
    selector: 'app-media-overview',
    templateUrl: './media-overview.component.html',
    styleUrls: ['./media-overview.component.scss']
})
export class MediaOverviewComponent implements OnInit {
    /** table  **/
    @Input() summaryData;
    public ELEMENT_DATA: MediasList[] = [
        {
            media: 'infiniti.jpg',
            rule: 'generic',
            plays: '108',
            impressions: '2.900',
            budget: 'USD 5,500.00',
            cost: 'USD 5,000.00'
        },
        {
            media: 'etisalat-5g.jpg',
            rule: 'generic',
            plays: '108',
            impressions: '2.900',
            budget: 'USD 5,500.00',
            cost: 'USD 5,000.00'
        },
        {
            media: 'infiniti.jpg',
            rule: 'generic',
            plays: '108',
            impressions: '2.900',
            budget: 'USD 5,500.00',
            cost: 'USD 5,000.00'
        }
    ];

    displayedColumns: string[] = ['media', 'rule', 'plays', 'impressions', 'cost'];

    mediaUrl = environment.apiUrl;
    dataSource = new MatTableDataSource<MediasList>(this.ELEMENT_DATA);

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    public constructor() { }

    ngOnInit(): void {
        if (this.summaryData) {
            this.dataSource = new MatTableDataSource(this.summaryData.mediaOverviews);
        }
    }
}
